module.exports = __webpack_public_path__ + "img/4f_r_twodays@2x.91b6fe7c.png";